import "Data/ServerSource";
/** @namespace Dict.Data */
NS("Dict.Data");

/**
 * Dict.Data.DynamicDictRows source
 * @class
 * @extends Data.ServerSource
 */
Dict.Data.DynRecords = Class(Data.ServerSource, /** @lends Dict.Data.DynRecords.prototype */ {
    url: "Dict/Web/DynRecords/",
    fields: [
        { name: "id", title: "id" }, // int
        { name: "dictid", title: "dictid" }, // int
        { name: "key", title: "key" }, // string
        { name: "value", title: "value" }, // string

        { name: "createddatetime", title: "createddatetime" }, // string
        { name: "modifieddatetime", title: "modifieddatetime" }, // string
        { name: "creator", title: "creator" }, // json
        { name: "modifier", title: "modifier" }, // json
    ],
});
